<template>
  <div class="has-logo">
    <logo :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :default-active="activeMenu" :collapse="isCollapse" :background-color="variables.menuBg"
        :text-color="variables.menuText" :active-text-color="variables.menuActiveText" mode="vertical">
        <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import SidebarItem from './SidebarItem'
  import variables from '@/styles/variables.scss'
  import Logo from './Logo'
  export default {
    components: {
      SidebarItem,
      Logo
    },
    data() {
      return {
        activeMenu: ''
      }
    },
    computed: {
      ...mapGetters([
        'permission_routers',
        'sidebar'
      ]),
      variables() {
        return variables
      },
      isCollapse() {
        return !this.sidebar.opened
      }
    },
    watch: {
      $route: {
        handler: function(val, oldVal) {
          if (val.meta && val.meta.activeMenu) this.activeMenu = val.meta.activeMenu
          else this.activeMenu = val.path
        },
        deep: true
      }
    },
    created() {
      if (this.$route.meta && this.$route.meta.activeMenu) this.activeMenu = this.$route.meta.activeMenu
      else this.activeMenu = this.$route.path
    },
  }
</script>
